import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const ZenMinimalOutro: React.FC<OutroProps> = ({
  keywords,
  frame,
  fps,
}) => {
  const pulseScale = 1.0 + Math.sin((frame / fps) * Math.PI * 1.5) * 0.04;

  return (
          <div
            style={{
              width: "100%",
              padding: "52px 32px",
              borderLeft: "2px solid rgba(192,57,43,0.4)",
              display: "flex",
              flexDirection: "column",
              gap: "24px",
            }}
          >
            <div
              style={{
                fontFamily: "'Lato', sans-serif",
                fontSize: "11px",
                fontStyle: "italic",
                color: "#8c7b68",
                letterSpacing: "4px",
              }}
            >
              follow
            </div>
            <h2
              style={{
                fontFamily: "'Noto Serif JP', serif",
                fontSize: "44px",
                fontWeight: 400,
                color: "#1a1a18",
                lineHeight: 1.4,
                margin: 0,
              }}
            >
              Never Miss A Moment
            </h2>
            <div
              style={{
                transform: `scale(${pulseScale})`,
                alignSelf: "flex-start",
                borderBottom: "1px solid #c0392b",
                paddingBottom: "4px",
              }}
            >
              <span
                style={{
                  fontFamily: "'Noto Serif JP', serif",
                  fontSize: "22px",
                  fontWeight: 400,
                  color: "#c0392b",
                }}
              >
                🔔 Follow
              </span>
            </div>
            <div
              style={{
                fontFamily: "'Lato', sans-serif",
                fontSize: "18px",
                color: "#8c7b68",
                letterSpacing: "2px",
              }}
            >
              {keywords?.[1] || "@TheDigitalBullet"}
            </div>
          </div>
        )
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
